/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Dropdown, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  dataLoading,
  folder,
  logosicon,
  marketingicon,
  trainingicon,
} from "../../assets/assets";
import Folder from "../../Modal/Assets/Folder/Folder";
import {
  setAddAssestsFolder,
  setShimmerImg,
  setShowAssets,
  setShowSelectedFolderData,
} from "../../Redux/Slices/MainSlice";
import httpApiCall from "../../service/api.service";
import { getStorageValue } from "../../service/shared.service";
import toastr from "../elements/toast";
import "./Assests.scss";
import Logos from "./Logos/Logos";
import MarketMaterial from "./MarketMaterial/MarketMaterial";
import MyAssets from "./MyAssets/MyAssets";
import TrainingMaterial from "./TrainingMaterial/TrainingMaterial";
const token = getStorageValue("partnerToken");

const toastrService = new toastr(true);

const Assests = () => {
  // const [shimmer, setShimmer] = useState(false);
  const [assetsFolderData, setAssetsData] = useState([]);
  const [assets, setAssets] = useState(1);
  const [tabactive, setTabactive] = useState(1);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [goToHome, setGoToHome] = useState(true);
  const [showFilter, setShowFilter] = useState(false);
  const [showCreateFolderModal, setShowCreateFolderModal] = useState(false);
  const [values, setvalues] = useState<any>();

  const assetsDataRedex = useSelector(
    (state: any) => state?.AssetsData.showAssets
  );
  const shimmer = useSelector((state: any) => state?.AssetsData.shimmer);
  const assetsData = useSelector(
    (state: any) => state?.AssetsData.addAssestsFolder
  );
  const dispatch = useDispatch();
  let profileData = getStorageValue("partnerProfile");
  profileData = profileData && profileData[0];

  useEffect(() => {
    callApi();
    dispatch(setShimmerImg(true));
  }, []);

  const callApi = async () => {
    const assestsFolderData: any = await getFolders(profileData);
    dispatch(setShimmerImg(false));
    if (assestsFolderData) {
      setAssetsData(assestsFolderData.data);
      if (assestsFolderData.data.length > 0 && assetsDataRedex.showAssets) {
        setSelectedIndex(assetsFolderData.length - 1);
        dispatch(
          setShowSelectedFolderData({
            showSelectedFolderData:
              assestsFolderData.data[assetsFolderData.length - 1],
          })
        );
      } else if (
        assestsFolderData.data.length == 0 &&
        assetsDataRedex.showAssets
      ) {
        setGoToHome(true);
        dispatch(
          setShowSelectedFolderData({
            showSelectedFolderData: assestsFolderData.data,
          })
        );
      } else {
        setGoToHome(true);
        dispatch(
          setShowSelectedFolderData({
            showSelectedFolderData: assestsFolderData.data,
          })
        );
      }
    }
  };

  const assetsTabs = [
    {
      id: 1,
      name: "Assets by Credee",
    },
    {
      id: 2,
      name: "My Assets",
    },
  ];

  const tabsArray = [
    {
      id: 1,
      name: "Logos",
      icon: logosicon,
    },
    {
      id: 2,
      name: "Marketing Materials",
      icon: marketingicon,
    },
    {
      id: 3,
      name: "Training Materials",
      icon: trainingicon,
    },
  ];

  const checkAssets = (index: any) => {
    const count = index + 1;
    setAssets(count);
    dispatch(setShowAssets({ showAssets: false }));
    // if(assets == 2){
    //   this._renderer.removeClass(document.body, 'modal-open');
    //   this._renderer.removeClass(document.body, 'modal-backdrop');
    // }
    // localStorage.setItem('selectAssetsTab',this.assets)
  };

  const assetstabs = (id: any) => {
    setTabactive(id);
  };

  const selectFol = (index: any, val: any) => {
    dispatch(setShowAssets({ showAssets: true }));
    setGoToHome(false);
    setSelectedIndex(index);
    dispatch(setShowAssets({ showSelectedFolderData: val }));
  };

  const showFolder = (item: any, value: any) => {
    if (value && value.id) {
      setShowFilter(false);
    }
    let val = {
      type: item,
      value: value,
    };
    setvalues(val);
    dispatch(setAddAssestsFolder(val));
    // dispatch(setName(true));
    // setShowCreateFolderModal(true);
  };

  const showLabels = (index: any) => {
    setShowFilter(!showFilter);
    setSelectedIndex(index);
  };

  const deleteFolder = (val: any) => {
    let data = {
      type: "delete",
      id: val,
      navigateToHome: true,
    };
    dispatch(setAddAssestsFolder(data));
    setShowFilter(!showFilter);
    // <MyAssets  onallApi={callApi} />;
  };

  const onEvent = (event: any) => {
    event.stopPropagation();
  };
  return (
    <div className="common_layout__right--inner-wrap pb-0">
      <div className="row justify-content-center">
        <div className="col-xxl-10 col-12">
          <div className="row assetstabs-bg mt-4 mx-2 mx-md-0">
            {assetsTabs.map((item, index) => (
              <div
                className="col-6 p-0"
                key={item.id}
                onClick={() => checkAssets(index)}
              >
                <div
                  id={item.id.toString()}
                  className={
                    `${assets == item.id ? "active" : ""}` + ` assetstab`
                  }
                >
                  <div className="tabs">
                    <h5>{item.name}</h5>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="p-4 p-xl-0">
            <div className="row">
              {((!goToHome && assets == 2 && assetsFolderData.length) ||
                assets == 1) && (
                <>
                  <div className="col-md-4 col-xl-3  d-none d-lg-block">
                    <div className="sidetabs">
                      {assets == 1 ? (
                        <>
                          <div>
                            {tabsArray.map((item) => (
                              <div
                                key={item.id}
                                // className="materials-tabs"
                                className={
                                  `${tabactive == item.id ? "active" : ""}` +
                                  ` materials-tabs`
                                }
                                id={item.id.toString()}
                                onClick={(event) => assetstabs(item.id)}
                              >
                                <span className="me-2">
                                  <img src={item.icon} alt="" />
                                </span>
                                {item.name}
                              </div>
                            ))}
                          </div>
                        </>
                      ) : (
                        assets == 2 && (
                          <>
                            <div>
                              <ul className="doc--list">
                                {assetsFolderData.map(
                                  (item: any, index: any) => (
                                    <li
                                      key={item.id}
                                      className={
                                        selectedIndex === index ? "active" : ""
                                      }
                                    >
                                      <div
                                        className="doc--list--inner"
                                        onClick={() => selectFol(index, item)}
                                      >
                                        <img src={folder} alt="" />
                                        <span
                                          className="d-inline-block position-relative"
                                          style={{ marginTop: "9px" }}
                                        >
                                          {item.folder_name}
                                        </span>
                                        {/* {showFilter &&
                                          selectedIndex == index && ( */}
                                        {
                                          <Dropdown
                                            style={{ flex: "auto" }}
                                            className="d-flex dropdown-custom-menu justify-content-end"
                                          >
                                            <Dropdown.Toggle
                                              variant="Secondary"
                                              id="dropdown-basic"
                                            >
                                              <svg
                                                className="more--icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="28"
                                                height="25"
                                                viewBox="0 0 28 25"
                                                fill="none"
                                              >
                                                <path
                                                  d="M14.5 14C15.3284 14 16 13.3284 16 12.5C16 11.6716 15.3284 11 14.5 11C13.6716 11 13 11.6716 13 12.5C13 13.3284 13.6716 14 14.5 14Z"
                                                  fill="#131921"
                                                />
                                                <path
                                                  d="M19.5 14C20.3284 14 21 13.3284 21 12.5C21 11.6716 20.3284 11 19.5 11C18.6716 11 18 11.6716 18 12.5C18 13.3284 18.6716 14 19.5 14Z"
                                                  fill="#131921"
                                                />
                                                <path
                                                  d="M9.5 14C10.3284 14 11 13.3284 11 12.5C11 11.6716 10.3284 11 9.5 11C8.67157 11 8 11.6716 8 12.5C8 13.3284 8.67157 14 9.5 14Z"
                                                  fill="#131921"
                                                />
                                              </svg>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                              <Dropdown.Item
                                                onClick={() =>
                                                  showFolder("edit", item)
                                                }
                                              >
                                                Rename
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                onClick={() =>
                                                  deleteFolder(item.id)
                                                }
                                              >
                                                Delete
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                          // <div
                                          //   className="dropdown-menu dropmenu"
                                          //   onClick={() =>
                                          //     setShowFilter(!showFilter)
                                          //   }
                                          // >
                                          //   <a
                                          //     className="dropdown-item"
                                          //     onClick={(event: any) => {
                                          //       onEvent(event);
                                          //       showFolder("edit", item);
                                          //     }}
                                          //   >
                                          //     Rename
                                          //   </a>
                                          //   <a
                                          //     className="dropdown-item"
                                          //     onClick={(event) => {
                                          //       onEvent(event);
                                          //       deleteFolder(item.id);
                                          //     }}
                                          //   >
                                          //     Delete
                                          //   </a>
                                          // </div>
                                        }
                                      </div>
                                    </li>
                                  )
                                )}
                              </ul>
                            </div>
                          </>
                        )
                      )}
                    </div>
                  </div>
                <div className="d-lg-none">
                {assets == 1 && (
                    <div className="custom-select-wrapper">
                    <Form.Select
                        aria-label="Default select example"
                        className="w-100 mb-3"
                        value={tabactive}
                        onChange={(event :any) => assetstabs(event.target.value)}
                    >
                        {tabsArray.map((item :any) => (
                            <option key={item.id} value={item.id} className="materials-tabs">
                                {item.name}
                            </option>
                        ))}
                    </Form.Select>
                </div>
                  )}
                   {assets == 2 && (
                    <div className="custom-select-wrapper2">
                    <Form.Select
                        aria-label="Default select example"
                        className="w-100 mb-3"
                        value={tabactive}
                        onChange={(event) => assetstabs(event.target.value)}
                    >
                        {assetsFolderData.map((item :any) => (
                            <option key={item.id} value={item.id} className="materials-tabs">
                                {item.folder_name}
                            </option>
                        ))}
                    </Form.Select>
                </div>
                  )}
                </div>

                  {/* <div className="col-9">

                  <h1>Hiiii</h1>

                </div> */}
                </>
              )}
              <div className="col-custom">
                {assets == 1 ? (
                  <>
                    <Logos tabactive={tabactive} />
                    <MarketMaterial tabactive={tabactive} />
                    <TrainingMaterial tabactive={tabactive} />
                  </>
                ) : (
                  <MyAssets onCallApi={callApi} />
                )}
                {shimmer && (
                  <div className="no_data_v2 text-center">
                    <img src={dataLoading} alt="" />
                  </div>
                )}
                <div className="pb-4 pb-md-0">
                  {goToHome && assets == 2 && !shimmer && (
                    <div className="row">
                      {assetsFolderData.map((row: any, index) => (
                        <div className="col-lg-3" key={index}>
                          <div
                            className="logos-card--media"
                            onClick={() => selectFol(index, row)}
                          >
                            <img src={folder} alt="" />
                          </div>
                          <div className="bottom-info">
                            <span
                              className="d-inline-block position-relative"
                              style={{ marginTop: "9px" }}
                            >
                              {row?.folder_name}
                            </span>
                            {/* {showFilter && selectedIndex == index && ( */}
                            {
                              <Dropdown className="d-inline-block float-end dropdown-custom-menu">
                                <Dropdown.Toggle
                                  variant="Secondary"
                                  id="dropdown-basic"
                                >
                                  <svg
                                    onClick={() => showLabels(index)}
                                    className="float-end"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="25"
                                    viewBox="0 0 28 25"
                                    fill="none"
                                  >
                                    <path
                                      d="M14.5 14C15.3284 14 16 13.3284 16 12.5C16 11.6716 15.3284 11 14.5 11C13.6716 11 13 11.6716 13 12.5C13 13.3284 13.6716 14 14.5 14Z"
                                      fill="#131921"
                                    />
                                    <path
                                      d="M19.5 14C20.3284 14 21 13.3284 21 12.5C21 11.6716 20.3284 11 19.5 11C18.6716 11 18 11.6716 18 12.5C18 13.3284 18.6716 14 19.5 14Z"
                                      fill="#131921"
                                    />
                                    <path
                                      d="M9.5 14C10.3284 14 11 13.3284 11 12.5C11 11.6716 10.3284 11 9.5 11C8.67157 11 8 11.6716 8 12.5C8 13.3284 8.67157 14 9.5 14Z"
                                      fill="#131921"
                                    />
                                  </svg>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    onClick={() => showFolder("edit", row)}
                                  >
                                    Rename
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => deleteFolder(row.id)}
                                  >
                                    Delete
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                              // <div
                              //   className="dropdown-menu dropmenu"
                              //   onClick={() => setShowFilter(!showFilter)}
                              // >
                              //   <a
                              //     className="dropdown-item"
                              //     onClick={(event) => {
                              //       onEvent(event);
                              //       showFolder("edit", row);
                              //     }}
                              //   >
                              //     Rename
                              //   </a>
                              //   <a
                              //     className="dropdown-item"
                              //     onClick={(event) => {
                              //       onEvent(event);
                              //       deleteFolder(row.id);
                              //     }}
                              //   >
                              //     Delete
                              //   </a>
                              // </div>
                            }
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {showCreateFolderModal && (
        <Folder
          show={showCreateFolderModal}
          onHide={() => {
            setShowCreateFolderModal(false);
          }}
          type={2}
          folderId={values.value.id}
          fileType={1}
          fileId={1}
          editFileld={0}
          subId={0}
        />
      )} */}
    </div>
  );
};

export default Assests;

const getFolders = async (partnerProfileData: any) => {
  try {
    const body = {
      access_token: token,
      partner_id: partnerProfileData.partner_id,
    };

    const response = await httpApiCall({
      api: "get_assets_folders",
      type: "post",
      body,
    });

    if (response && response.is_error) {
      toastrService.showError(response.original_text || response.err);
    } else {
      return response;
    }
  } catch (error) {
    toastrService.showError(error);
  }
};
